import { Actions } from '../actionTypes/actionTypes';

export const deferDealRefreshModal = () => ({ type: Actions.DEFER_DEAL_REFRESH_MODAL });
